import { Component, effect, computed, Signal, signal, WritableSignal, ViewChild } from '@angular/core';
import { StoreFeature, StoreFeatureConfiguration } from 'src/app/models/types/Configuration/Settings.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { StoreFeaturesList } from 'src/app/models/constants/store-services.constant';
import { Feature } from 'src/app/models/enums/Feature.enum';
import { FullScreenModalComponent } from '../modals/full-screen-modal/full-screen-modal.component';
import { RibbonModalComponent } from '../modals/ribbon-modal/ribbon-modal.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-my-bulgari-page',
  imports: [SharedModule, BreadcrumbComponent, RibbonModalComponent],
  templateUrl: './my-bulgari-page.component.html',
  styleUrl: './my-bulgari-page.component.scss'
})
export class MyBulgariPageComponent {

  @ViewChild('ribbonModal', { static: false }) ribbonModal!: RibbonModalComponent;

  public storeConfiguration: WritableSignal<StoreFeatureConfiguration | undefined> = signal(undefined);
  // public storeFeatures: WritableSignal<StoreFeature[]> = signal([]);

  constructor(
    public readonly authService: AuthService,
    private readonly sharedService: SharedService,
  ) {
    // let storeFeatureConfig = this.authService.storeFeatureConfiguration();
    // this.storeConfiguration.set(storeFeatureConfig);
    // let availableFeatures = storeFeatureConfig?.availableFeatures;
    // if (availableFeatures) {
    //   availableFeatures.forEach(feature => {
    //     let storeFeature = StoreFeaturesList.get(feature);
    //     if (!storeFeature) {
    //       console.warn(`Feature ${feature} not found in StoreFeaturesList`);
    //     } else {
    //       this.storeFeatures.update(features => [...features, storeFeature]);
    //     }
    //   });
    // }
    // this.storeFeatures.update(features => [...features, StoreFeaturesList.get(Feature.MTO_OCTO)!]);

  }

  handleFeatureClick(feature: Feature) {
    switch (feature) {
      case Feature.MTO_OCTO: {
        window.open(environment.mtoUrl, '_blank', 'noopener');
        break;
      };
      case Feature.RIBBON: {
        this.ribbonModal.openModal();
        break;
      }
    }
  }


  handleLogoutClick() {
    this.authService.logout();
  }

  handleChangeStoreClick() {
    this.sharedService.navigateTo_SetStorePage();
  }
}
